import axios from "axios";

export default {
    getAllBoxesExcel(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/boxes/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllVisitTypesExcel(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.types/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionalsExcel(data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/professionals/performance/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findAllBoxes(idOrganization, currentPage = 0, pageSize = 10, filter) {
        return axios({
            method: "post",
            data: filter,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/boxes?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveBox(idOrganization, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/box",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findProfessionalsIprosOrganization(idOrganization) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/professionals/ipros",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateBox(id, idOrganization, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/box/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteBox(id, idOrganization) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/box/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findBox(id, idOrganization) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                idOrganization +
                "/box/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findLogo(organization) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/organization/" +
                organization +
                "/logo",
        });
    },
    updateAdminCita(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organization/admin/cita",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    update(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organization",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organizations",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organization/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPatientsById(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                id +
                "/patients",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionalsByIdActive(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                id +
                "/professionals/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionalsById(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                id +
                "/professionals",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionalsPerformance(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/professionals/performance?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionals() {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/organization/professionals",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllParams(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/params",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    activateQuestionary(organizationId, questionaryId) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/questionary/" +
                questionaryId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getOrganizationValoration(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/questionary/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllVisitTypes(organizationId, currentPage = 0, pageSize = 10, filter) {
        return axios({
            method: "post",
            data: filter,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.types?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllVisitTypesProfessional(organizationId, professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/professional/" +
                professionalId +
                "/visit.types",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getVisitTypeProfessional(organizationId, professionalId, visitTypeId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/professional/" +
                professionalId +
                "/visit.type/" +
                visitTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getVisitType(organizationId, visitTypeId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.type/" +
                visitTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteVisitType(organizationId, visitTypeId) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.type/" +
                visitTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveActiveStatusVisitTypeProfessional(
        organizationId,
        professionalId,
        visitTypeId,
        active
    ) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/professional/" +
                professionalId +
                "/visit.type/" +
                visitTypeId +
                "/active/" +
                active,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveActiveStatusVisitType(organizationId, visitTypeId, active) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.type/" +
                visitTypeId +
                "/active/" +
                active,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateVisitTypeProfessional(
        organizationId,
        professionalId,
        visitTypeId,
        data
    ) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/professional/" +
                professionalId +
                "/visit.type/" +
                visitTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateVisitType(organizationId, visitTypeId, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.type/" +
                visitTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTaxes(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/taxes",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPaymentOutPlataform(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/paymentOutPlataform",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createPaymentOutPlataform(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/paymentOutPlataform",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    savePaymentOutPlataformActive(organizationId, paymentOutPlataformId, active) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/paymentOutPlataform/" +
                paymentOutPlataformId +
                "/active/" +
                active,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deletePaymentOutPlataform(organizationId, paymentOutPlataformId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/paymentOutPlataform/" +
                paymentOutPlataformId +
                "/delete",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getHelp(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/help",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateHelp(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/help",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateParam(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/param",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createVisitTypeProfessional(organizationId, professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/professional/" +
                professionalId +
                "/visit.type",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createVisitType(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/visit.type",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createProfessional(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organization/professional",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllProfessionals() {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/organization/professionals",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getProfessional(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/professional/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    sendInvitationProfessional(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/professional/send/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/organizations",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findAllInvoicesCitaById(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/invoices/cita",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findAllPlanTypeById(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planTypes",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createPlanType(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updatePlanType(organizationId, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deletePlanType(organizationId, planTypeId) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType/" +
                planTypeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    activePlanTypePremium(organizationId, planTypeId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType/" +
                planTypeId +
                "/premium/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    activePlanType(organizationId, planTypeId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType/" +
                planTypeId +
                "/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    planTypeActive(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/planType/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    checkStripe(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/stripe/check",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    checkPaypal(organizationId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/paypal/check",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getUsersByOrganization(organizationId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/organization/" +
                organizationId +
                "/users",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
